// Ubicación y cámara de la app: el navegador no deja quitarse un permiso a sí mismo, así que «desactivar» es un
// interruptor de la app en ESTE dispositivo (localStorage): mientras esté apagado, el fichaje no usa ese permiso y no se puede fichar.
// Volver a activarlo lo enciende (y el navegador vuelve a preguntar si hace falta).
const CLAVE = (k) => `ch_permiso_${k}_off`;     // k: "ubicacion" | "camara"

export const permisoDesactivado = (k) => { try { return localStorage.getItem(CLAVE(k)) === "1"; } catch (_) { return false; } };

export const setPermisoDesactivado = (k, off) => {
  try { if (off) localStorage.setItem(CLAVE(k), "1"); else localStorage.removeItem(CLAVE(k)); } catch (_) { /* sin almacenamiento */ }
  window.dispatchEvent(new Event("permisos:cambio"));
};
